import { OnBoarding } from './on-boarding.types';

const INITIAL_STATE = {

    orderDetails: '',
    name: '',
	mobile: '',
	aadhaarNumber: '',
	panNumber: '',

    uniqueRefNo:'',
    rblUniqueRefNo:'',

    currentState: false,
    previousState: false
};

const onBoardingReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case OnBoarding.SET_ORDER_DETAILS:
            return {
                ...state,
                orderDetails:action.payload.orderDetails,
            };
        case OnBoarding.SET_UPDATED_DETAILS:
            return {
                ...state,
                name:action.payload.name,
                mobile:action.payload.mobile,
                aadhaarNumber:action.payload.aadhaarNumber,
                panNumber:action.payload.panNumber,
            };  
        case OnBoarding.SET_UNIQUE_REF_NO:
            return {
                ...state,
                uniqueRefNo:action.payload.uniqueRefNo,
            };
        case OnBoarding.SET_RBL_UNIQUE_REF_NO:
            return {
                ...state,
                rblUniqueRefNo:action.payload.rblUniqueRefNo,
            };
        case OnBoarding.SET_CURRENT_STATE:
            return {
                ...state,
                currentState: true,
                previousState: false
            };
        case OnBoarding.SET_PREVIOUS_STATE:
            return {
                ...state,
                currentState: false,
                previousState: true
            };
        case OnBoarding.RESET:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default onBoardingReducer;